"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.POPULAR_TLDS = exports.POPULAR_DOMAINS = exports.run = void 0;

var run_1 = __importDefault(require("./lib/run"));

exports.run = run_1.default;

var config_1 = require("./lib/config");

Object.defineProperty(exports, "POPULAR_DOMAINS", {
  enumerable: true,
  get: function get() {
    return config_1.POPULAR_DOMAINS;
  }
});
Object.defineProperty(exports, "POPULAR_TLDS", {
  enumerable: true,
  get: function get() {
    return config_1.POPULAR_TLDS;
  }
});
var MailSpellChecker = {
  run: run_1.default,
  POPULAR_DOMAINS: config_1.POPULAR_DOMAINS,
  POPULAR_TLDS: config_1.POPULAR_TLDS
};
exports.default = MailSpellChecker;